export const stepNamePrefix = 'profile-setup'

export const steps = {
  welcome: `${stepNamePrefix}-welcome`,
  address: `${stepNamePrefix}-your-address`,
  deliveryPreferenceIntro: `${stepNamePrefix}-delivery-preference-intro`,
  deliveryPreference: `${stepNamePrefix}-delivery-preference`,
  deliveryPreferenceToDoor: `${stepNamePrefix}-delivery-preference-to-door`,
  deliveryPreferenceServicePointList: `${stepNamePrefix}-delivery-preference-servicepoint-list`,
  deliveryPreferenceServicePointSelect: `${stepNamePrefix}-delivery-preference-servicepoint-select`,
  deliveryPreferenceAgreedPlace: `${stepNamePrefix}-delivery-preference-agreed-place`,
  additionalEmailAddress: `${stepNamePrefix}-email-address`,
  phoneNumber: `${stepNamePrefix}-phone-number`,
  phoneNumberVerification: `${stepNamePrefix}-phone-number-verification`,
  notificationPreference: `${stepNamePrefix}-notification-preference`,
  done: `${stepNamePrefix}-done`,
}

export const stepWizardId = 'setup-wizard-step'
